import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AlertPaymentService } from '../shared/services/alert-payment.service';
import { AccountService } from '../shared/services/account.service';
import { Ng1IpInfoService } from '../shared/ng1/ng1-ip-info.service';
import { FreePortingDialogComponent } from './free-porting-dialog/free-porting-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-get-number',
  templateUrl: './get-number.component.html',
  styleUrls: ['./get-number.component.scss']
})
export class GetNumberComponent implements OnInit {
  public failedPayment: boolean;
  public isFullyConfigured: boolean;

  constructor(
    private alertPaymentService: AlertPaymentService,
    private accountService: AccountService,
    private ng1IpInfoService: Ng1IpInfoService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failedPayment = isPaymentFailed;
    });
    this.accountService.getAccountConfig().subscribe(conf => {
      this.isFullyConfigured = conf.data;
    });
  }

  onToBarClicked() {
    this.isFullyConfigured ? this.goToBusinessNumber() : this.showFreePortingPopup();
  }

  private goToBusinessNumber() {
    const code = this.ng1IpInfoService.getCountry().toLowerCase();
    this.router.navigate(['exists-number', code]);
  }

  private showFreePortingPopup() {
    this.dialog.open(FreePortingDialogComponent, {});
  }
}
